import { GetApiIntroducerPortalDirectorSearchResponse } from '@iwoca/lapi-client/introducer_portal';
import { Input, Label } from '@iwoca/orion';
import { useAmplitude } from 'hooks/useAmplitude';
import { FieldErrors, UseFormRegister } from 'react-hook-form';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';
import styles from '../NewSignupForm.module.css';
import { TNewSignupFormData } from '../NewSignupForm.types';

type TProps = {
  register: UseFormRegister<TNewSignupFormData>;
  errors: FieldErrors<TNewSignupFormData>;
  selectedPerson?: GetApiIntroducerPortalDirectorSearchResponse['data'][number];
};

export const DateOfBirthInput = ({
  register,
  errors,
  selectedPerson,
}: TProps) => {
  const { trackEvent } = useAmplitude();
  const handleDOBTracking = () => {
    trackEvent(AMPLITUDE_EVENTS.dobUpdated);
  };

  const reintroducedPersonSelected =
    selectedPerson && 'state_key' in selectedPerson;

  const disabled = !selectedPerson || reintroducedPersonSelected;

  return (
    <div className={styles.formField}>
      <div className={styles.labelWithTooltip}>
        <Label>Date of birth</Label>
      </div>
      <div className={styles.dobContainer}>
        <Input
          {...register('dobDay')}
          placeholder="DD"
          data-testid="dob-day"
          onChange={handleDOBTracking}
          error={errors.dobDay?.message}
          disabled={disabled}
        />
        <Input
          {...register('dobMonth')}
          placeholder="MM"
          data-testid="dob-month"
          onChange={handleDOBTracking}
          error={errors.dobMonth?.message}
          disabled={disabled}
        />
        <Input
          {...register('dobYear')}
          placeholder="YYYY"
          data-testid="dob-year"
          onChange={handleDOBTracking}
          error={errors.dobYear?.message}
          disabled={disabled}
        />
      </div>
    </div>
  );
};
